import { AxiosError, HttpStatusCode } from 'axios'
import Image from 'next/image'
import { FC } from 'react'

import { ServerValidationError } from '@/api/shared/types'
import { ScreenSize, SOMETHING_WENT_WRONG } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { ErrorCard } from '@/components/pages/plugs/ErrorCard'
import { ErrorForbidden } from '@/components/pages/plugs/ErrorForbidden'
import { AppButton } from '@/components/shared/button'

type Props = {
  isForbidden?: boolean
  closeDrawer?: () => void
  formError?: AxiosError<ServerValidationError> | null
  isEditingError?: boolean
}

const ErrorDrawerContent: FC<Props> = ({
  isForbidden,
  closeDrawer,
  formError,
  isEditingError
}) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [ScreenSize.Xxs].includes(breakpoint)

  const status = formError?.response?.status
  const isServerError =
    status !== undefined &&
    status !== null &&
    status >= HttpStatusCode.InternalServerError

  /**
   * isShowTitleError - показываем текст ошибки от бэка вместо стандартного описания.
   * На экране редактирования данных о ТС текст бэка не выводим:
   * туда доходят только ошибки, которые не показываются в самой форме,
   * и для них по макету остаётся только "Что-то пошло не так..."
   */
  const isShowTitleError =
    !isEditingError &&
    !isServerError &&
    status === HttpStatusCode.BadRequest &&
    !formError?.response?.data.errors.length

  if (isForbidden) {
    return (
      <ErrorForbidden
        isTitle
        className="mb-0"
        descriptionClassName="font-bold !text-black !text-24 sm:!text-14"
      />
    )
  }

  return (
    <>
      {isEditingError ? (
        <div className="mt-[200px] flex flex-col items-center gap-20">
          <Image
            src="/images/shared/Blocked.png"
            alt="image"
            width={isMobileScreen ? 90 : 180}
            height={isMobileScreen ? 90 : 180}
          />
          <p className="text-center text-grey-80 text-20 xxs:text-16">
            {SOMETHING_WENT_WRONG}...
          </p>
        </div>
      ) : (
        <div className="mt-[200px]">
          <ErrorCard
            title={
              isShowTitleError ? formError?.response?.data.title : undefined
            }
          />
        </div>
      )}
      <AppButton className="mt-auto" variant="secondary" onClick={closeDrawer}>
        Понятно
      </AppButton>
    </>
  )
}

export { ErrorDrawerContent }
